import posthog from 'posthog-js';

export const initPosthog = () => {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;
  posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com',
    capture_pageview: true,
    capture_pageleave: true,
    person_profiles: 'identified_only',
  });
};

export const identifyUser = (userId: string | number, properties: { username?: string; email?: string }) => {
  posthog.identify(String(userId), properties);
  posthog.stopSessionRecording();
};

export const resetUser = () => {
  posthog.reset();
  posthog.startSessionRecording();
};

export const track = (event: string, properties?: Record<string, unknown>) => {
  posthog.capture(event, properties);
};

export const setUserProperties = (properties: Record<string, unknown>) => {
  posthog.setPersonProperties(properties);
};
